import { approval } from '@/api/approval'
import { common } from '@/api/common'
import { setting } from '@/api/services'
import store from '@/store'

let res = null

export const approvals = {
    namespaced: true,
    state: {
        filters: ['전체'],
        approvalList: null,
        approvalCategory: null,

        //결재현황,완료,반려/회수,참조,열람 리스트
        electapList: null,

        //우측 결재라인 선택모달
        approvalName: null, //결재선 상단 기안문서제목
        electapFormIdx: null, //결재선 폼 idx

        //결재라인 및 참조자,열람자, 결재관련정보(공통)
        line: null,
        refer: null,
        view: null,
        documentComment: null,
        documentNo: null,
        files: null,
        relDoc: null,
        electapDocumentIdx: null,
        process: null,
        createUser: null,
        updateYmd: null,

        //휴가신청 - 휴가구분
        vacationTypeList: null,

        //직원월례회의록 리스트
        meetingLog: null,
        attendanceList: null,

        //접수된 고충리스트
        distresses: null,

        //사례관리 리스트
        caseList: null,

        //운영위원회 리스트
        steeringCommitteeList: null,
        steeringAttendance: null,

        //SMS발송내역
        smsList: null,

        //물품관리대장 물품리스트
        itemList: null,
        itemPurchase: null,
        itemUsage: null,

        //관련문서 사례관리
        performList: null, //수행일지
        stateList: null, //상태변화기록지
        serviceList: null, //급여제공계획서
        selectedRecipient: null, //사례관리에 선택된 수급자

        //결제내역
        paymentHistory: null,

        //직원의 출퇴근현황
        staffCommuteList: null,
        yearHoliday: null,

        //포상관리
        rewardList: null,

        // 급여정산마감
        staffPayslipCloseList: null,

        //기관운영관리(결재) 대시보드
        managementDash: null,
        mgmtApproval: null,
        mgmtLimit: null,
        useDayList: null,
        between20And24List: null,
        count19AllList: null,
        count25AllList: null,
        countAllList: null,
        receiverGoal: null,

        // 교육일지 관리
        educationList: null,
    },
    mutations: {
        RESET_APPROVAL_FORM(state, payload) {
            state.line = null
            state.refer = null
            state.view = null
            state.documentComment = null
            state.documentNo = null
            state.files = null
            state.relDoc = null
            state.electapDocumentIdx = null
            state.process = null
            state.createUser = null
            state.updateYmd = null
        },
        APPROVAL_LIST(state, payload) {
            state.approvalList = payload.electapFormList
        },
        APPROVAL_CATEGORY(state, payload) {
            state.approvalCategory = payload.electapFormCategoryList
        },
        EXTRA_APPROVAL_NAME(state, payload) {
            state.approvalName = payload.name
            state.electapFormIdx = payload.idx
        },
        CLOSE_EXTRA_APPROVAL(state, payload) {
            state.approvalName = null
            state.electapFormIdx = null
        },
        SELECT_FILTER(state, payload) {
            state.filters = payload
        },
        ELECTAP_FORM_CODE(state, payload) { //미사용
            state.line = payload.electapForm.aprvLineList
            state.refer = payload.electapForm.aprvLineRefList
            state.view = payload.electapForm.aprvLineViewList
        },
        APPROVAL_COMMON(state, payload) {
            state.line = payload.electapDocument.aprvLineList
            state.refer = payload.electapDocument.aprvLineRefList
            state.view = payload.electapDocument.aprvLineViewList

            state.documentComment = payload.electapDocument.electapDocumentCommentList //의견글
            state.process = payload.electapDocument.electapDocumentVO.electroApprovalProcessCode //결재상태
            state.documentNo = payload.electapDocument.electapDocumentVO.documentNo //문서번호
            state.files = payload.electapDocument.electapDocumentFileList //첨부파일
            state.relDoc = payload.electapDocument.relatedDocList //관련문서
            state.electapDocumentIdx = payload.electapDocument.electapDocumentVO.electapDocumentIdx //문서idx
            state.createUser = payload.electapDocument.electapDocumentVO.createUserName //작성자
            state.updateYmd = payload.electapDocument.electapDocumentVO.updateYmdhms //기안일
            payload.vacationTypeList ? state.vacationTypeList = payload.vacationTypeList : null
        },
        //신규(휴가)
        VACATION_FORM(state, payload) {
            state.line = payload.electapForm.aprvLineList
            state.refer = payload.electapForm.aprvLineRefList
            state.view = payload.electapForm.aprvLineViewList
            state.vacationTypeList = payload.vacationTypeList
        },
        //신규(직원월례회의록)
        MEETING_LOG(state, payload) {
            state.line = payload.electapDocument.aprvLineList
            state.refer = payload.electapDocument.aprvLineRefList
            state.view = payload.electapDocument.aprvLineViewList
        },
        //상세(직원회의) -> 참석자 명단
        MEETING_LOG_DETAIL(state, payload) {
            state.attendanceList = payload.attendanceList
        },
        DELETE_MEETING_ATTENDANCE(state, payload) {
            state.attendanceList.splice(payload, 1)
            if (!state.attendanceList.length) state.attendanceList = null
        },
        DELETE_MEETING_ATTENDANCE_GROUP(state, payload) {
            let findIdx

            payload.data.forEach(element => {
                findIdx = state.attendanceList.findIndex(item => item.snsAttendanceIdx === element)

                if (findIdx > -1)
                    state.attendanceList.splice(findIdx, 1)
            })
        },
        RESET_MEETING_ATTENDANCE(state, payload) {
            state.attendanceList = null
        },
        //신규(교육일지)
        EDUCATION_LOG(state, payload) {
            state.line = payload.electapDocument.aprvLineList
            state.refer = payload.electapDocument.aprvLineRefList
            state.view = payload.electapDocument.aprvLineViewList
        },
        //신규(고충)
        DISTRESS_DETAIL(state, payload) {
            state.line = payload.electapDocument.aprvLineList
            state.refer = payload.electapDocument.aprvLineRefList
            state.view = payload.electapDocument.aprvLineViewList

            state.files = payload.electapDocument.electapDocumentFileList //첨부파일
        },
        //신규(사례)
        CASE_REPORT(state, payload) {
            state.line = payload.electapDocument.aprvLineList
            state.refer = payload.electapDocument.aprvLineRefList
            state.view = payload.electapDocument.aprvLineViewList
        },
        //신규(응급상황기록지)
        EMERGENCY_FORM(state, payload) {
            state.line = payload.electapForm.aprvLineList
            state.refer = payload.electapForm.aprvLineRefList
            state.view = payload.electapForm.aprvLineViewList
        },
        PAYSLIP_REPORT(state, payload) {
            state.line = payload.electapForm.aprvLineList
            state.refer = payload.electapForm.aprvLineRefList
            state.view = payload.electapForm.aprvLineViewList
        },
        ADD_DEFAULT_RECV(state, payload) {
            if (!state.line) {
                state.line = []
            }
            let index = state.line.findIndex(item => item.staffBaseIdx === Number(payload.staffBaseIdx))
            if (index !== -1) state.line.splice(index, 1)
            state.line.unshift(payload)
        },
        // SET_APPROVAL_FILES(state, payload) {
        //     state.files = payload
        // },
        // REMOVE_APPROVAL_FILES(state, payload) {
        //     state.files.splice(payload, 1)
        //     if(!state.files.length) state.files = null
        // },
        SET_APPROVAL_DOCUMENT(state, payload) {
            if (!state.relDoc) state.relDoc = []
            if (payload) {
                payload.forEach(item => {
                    state.relDoc.push({
                        refRelatedIdx: item.electapRelatedTypeCode === '11' ?
                            item.electapDocumentIdx : item.refRelatedIdx,
                        refDocumentNo: item.electapRelatedTypeCode === '11' ?
                            item.documentNo : item.electapRelatedTypeCode === '15' ? item.visitYmd : item.offerYmd,
                        electapRelatedTypeCode: item.electapRelatedTypeCode,
                    })
                })
            }
        },
        REMOVE_APPROVAL_DOCUMENT(state, payload) {
            state.relDoc.splice(payload, 1)
            if (!state.relDoc.length) state.relDoc = null
        },
        ADD_APPROVAL_LINE(state, payload) {
            switch (payload.type) {
                case 'line':
                    if (!state.line) state.line = []
                    state.line.push(payload.info)
                    break
                case 'ref':
                    if (!state.refer) state.refer = []
                    state.refer.push(payload.info)
                    break
                case 'view':
                    if (!state.view) state.view = []
                    state.view.push(payload.info)
                    break
            }
        },
        REMOVE_APPROVAL_LINE(state, payload) {
            switch (payload.type) {
                case 'line':
                    state.line.splice(payload.index, 1)
                    if (!state.line.length) state.line = null
                    break
                case 'ref':
                    state.refer.splice(payload.index, 1)
                    if (!state.refer.length) state.refer = null
                    break
                case 'view':
                    state.view.splice(payload.index, 1)
                    if (!state.view.length) state.view = null
                    break
            }
        },
        ELECTAP_LIST(state, payload) {
            state.electapList = payload.electapDocumentList
        },
        ELECTAP_COMMENT(state, payload) {
            if (!state.documentComment) state.documentComment = []
            state.documentComment.unshift(payload)
        },
        DELETE_ELECTAP_COMMENT(state, payload) {
            let index = state.documentComment.findIndex(item => item.electapDocumentCommentIdx === payload)
            state.documentComment.splice(index, 1)
            if (!state.documentComment.length) state.documentComment = null
        },
        DELETE_APPROVAL_FILE(state, payload) {
            let index = state.files.findIndex(item => item.commonAttachFileIdx === payload)
            state.files.splice(index, 1)
        },
        MEETING_LOG_LIST(state, payload) {
            state.meetingLog = payload.snsMeetingLogList
        },
        DISTRESSES_LIST(state, payload) {
            state.distresses = payload.distressesList
        },
        CASE_LIST(state, payload) {
            state.caseList = payload.electapDocumentList
        },
        SMS_LIST(state, payload) {
            state.smsList = payload.smsHistory
        },
        ITEM_LIST(state, payload) {
            state.itemList = payload.itemList
        },
        ITEM_PURCHASE_LIST(state, payload) {
            state.itemPurchase = payload.medicinePurchaseList
        },
        ITEM_USAGE_LIST(state, payload) {
            state.itemUsage = payload.itemUsageLogList
        },
        REGIST_ITEM_PURCHASE(state, payload) {
            let index = state.itemList.findIndex(item => item.medicineInfoIdx === payload.medicineInfoIdx)
            state.itemList[index].remainCount = state.itemList[index].remainCount + Number(payload.purchaseQuantity)
        },
        DELETE_ITEM_PURCHASE(state, payload) {
            let index = state.itemPurchase.findIndex(item => item.medicinePurchaseIdx === payload)
            state.itemPurchase.splice(index, 1)
            if (!state.itemPurchase.length) state.itemPurchase = null
        },
        REF_PERFORM_LIST(state, payload) {
            state.performList = payload.list
        },
        REF_STATE_LIST(state, payload) {
            state.stateList = payload.list
        },
        REF_SERVICE_LIST(state, payload) {
            state.serviceList = payload.list
        },
        SELECTED_RECIPIENT(state, payload) {
            state.selectedRecipient = payload
        },
        REWARD(state, payload) {
            state.line = payload.electapDocument.aprvLineList
            state.refer = payload.electapDocument.aprvLineRefList
            state.view = payload.electapDocument.aprvLineViewList
        },
        STAFF_RESIGN(state, payload) {
            state.line = payload.electapForm.aprvLineList
            state.refer = payload.electapForm.aprvLineRefList
            state.view = payload.electapForm.aprvLineViewList
        },
        STEERING_COMMITTEE(state, payload) {
            state.line = payload.electapForm.aprvLineList
            state.refer = payload.electapForm.aprvLineRefList
            state.view = payload.electapForm.aprvLineViewList
            state.steeringAttendance = payload.steeringCommitteeMinute.attendeeList

            state.steeringAttendance = []
                for(let i = 0; i < 20; i++) {
                    state.steeringAttendance.push({
                        duty: null,
                        attendeeName: null
                    })
                }
        },
        STEERING_COMMITTEE_DETAIL(state, payload) {
            state.steeringAttendance = payload.steeringCommitteeMinute.attendeeList
            if(!state.steeringAttendance) {
                state.steeringAttendance = []
                for(let i = 0; i < 23; i++) {
                    state.steeringAttendance.push({
                        duty: null,
                        attendeeName: null
                    })
                }
            } else {
                let size = state.steeringAttendance.length
                if(size < 20) {
                    for(let i = size; i < 23; i++) {
                        state.steeringAttendance.push({
                            duty: null,
                            attendeeName: null
                        })
                    }
                }
            }
        },
        RESET_STEERING_ATTENDANCE(state, payload) {
            state.steeringAttendance = null
        },
        STAFF_COMMUTE_APPROVAl(state, payload) {
            state.line = payload.electapForm.aprvLineList
            state.refer = payload.electapForm.aprvLineRefList
            state.view = payload.electapForm.aprvLineViewList
        },
        PAYMENT_HISTORY(state, payload) {
            state.paymentHistory = payload.paymentHistory
        },
        STAFF_COMMUTE_LIST(state, payload) {
            state.staffCommuteList = payload.rtnList
        },
        DELETE_STAFF_ALL_COMMUTE(state, payload) {
            let index = state.staffCommuteList.findIndex(item => item[0].staffBaseIdx === payload.rtnList[0].staffBaseIdx)
            if (index !== -1) {
                state.staffCommuteList.splice(index, 1, payload.rtnList)
            }
        },
        UPDATE_STAFF_COMMUTE(state, payload) {
            let index = state.staffCommuteList.findIndex(item => item[0].staffBaseIdx === payload.rtnList[0].staffBaseIdx)
            console.log(index)
            if (index !== -1) {
                state.staffCommuteList.splice(index, 1, payload.rtnList)
            }
        },
        REQUEST_CONFIRM(state, payload) {
            let index = state.staffCommuteList.findIndex(item => item[0].staffBaseIdx === payload.rtnList[0].staffBaseIdx)
            console.log(index)
            if (index !== -1) {
                state.staffCommuteList.splice(index, 1, payload.rtnList)
            }
        },
        DELETE_REQUEST(state, payload) {
            //삭제
        },
        PAYMENT_REFUND(state, payload) {
            let index = state.paymentHistory.findIndex(item => item.productPaymentIdx === payload.paymentInfo.productPaymentIdx)
            state.paymentHistory.splice(index, 1, payload.paymentInfo)
        },
        CLOSE_COMMUTE(state, payload) {
            console.log(index)
            let index = state.staffCommuteList.findIndex(item => item[0].staffBaseIdx === payload.rtnList[0].staffBaseIdx)
            if (index !== -1) {
                state.staffCommuteList.splice(index, 1, payload.rtnList)
            }
        },
        COMMON_APPROVAl(state, payload) {
            state.line = payload.electapForm.aprvLineList
            state.refer = payload.electapForm.aprvLineRefList
            state.view = payload.electapForm.aprvLineViewList
        },
        DAY_REPORT(state, payload) {
            state.line = payload.electapForm.aprvLineList
            state.refer = payload.electapForm.aprvLineRefList
            state.view = payload.electapForm.aprvLineViewList
        },
        ITEM_LIST_REPORT(state, payload) {
            state.line = payload.electapForm.aprvLineList
            state.refer = payload.electapForm.aprvLineRefList
            state.view = payload.electapForm.aprvLineViewList
        },
        REWARD_LIST(state, payload) {
            state.rewardList = payload.electapDocumentList
        },
        PAYSLIP_REPORT_TO_CLOSE(state, payload) {
            //
            state.staffPayslipCloseList = payload.staffPayslipCloseVO
        },
        MANAGEMENT_DASH(state, payload) {
            // state.useDayList = payload.useDayList
            state.mgmtApproval = payload.approvalList
            state.receiverGoal = payload.receiverGoalList
                // state.mgmtLimit = payload.limitAmountUseList
            state.managementDash = payload
        },
        USE_DAY(state, payload) {
            state.useDayList = payload.useDayList
            state.count25AllList = payload.count25AllList
            state.count19AllList = payload.count19AllList
            state.between20And24List = payload.between20And24List
            state.countAllList = payload.countAllList
        },
        DASH_LIMIT(state, payload) {
            state.mgmtLimit = payload.limitAmountUseList
        },
        REGIST_RECEIVER_GOAL(state, payload) {
            state.receiverGoal = payload.receiverGoalList
        },
        DELETE_RECEIVER_GOAL(state, payload) {
            state.receiverGoal = payload.receiverGoalList
        },
        YEAR_HOLIDAY(state, payload) {
            state.yearHoliday = payload.holidayList
        },
        APPROVAL_EDUCATION_LIST(state, payload) {
            state.educationList = payload.staffEducationList
        },
        ADD_ATTEND_STAFF_LIST(state, payload) {
            if (!state.attendanceList) state.attendanceList = []

            if (payload.attendanceList && payload.attendanceList.length > 0) {
                for (var i = 0; i < payload.attendanceList.length; i++) {
                    state.attendanceList.push(payload.attendanceList[i])
                }
            }
        },
        STEERING_COMMITTEE_LIST(state, payload) {
            state.steeringCommitteeList = payload.committeeList
        }
    },
    actions: {
        // @Description 문서 재기안
        async RE_APPROVAL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.post.reApproval(payload)
                console.log('RE_APPROVAL info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RE_APPROVAL', error)
            }
        },
        // @Description 결재양식 조회
        async APPROVAL_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.electapFormList(payload)
                console.log('APPROVAL_LIST info', res)
                if (res.data.status === 200) {
                    commit('APPROVAL_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('APPROVAL_LIST', error)
            }
        },
        // @Description 결재양식 카테고리 조회
        async APPROVAL_CATEGORY({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.electapFormCategory(payload)
                console.log('APPROVAL_CATEGORY info', res)
                if (res.data.status === 200) {
                    commit('APPROVAL_CATEGORY', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('APPROVAL_CATEGORY', error)
            }
        },
        // @Description 결재양식 상세조회
        async APPROVAL_DETAIL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.electapForm(payload)
                console.log('APPROVAL_DETAIL info', res)
                if (res.data.status === 200) {

                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('APPROVAL_DETAIL', error)
            }
        },
        // @Description 결재양식 저장
        async REGIST_APPROVAL_DETAIL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.post.electapForm(payload)
                console.log('REGIST_APPROVAL_DETAIL info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_APPROVAL_DETAIL', error)
            }
        },
        // @Description 결재선 삭제
        async DELETE_APPROVAL_LINE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.delete.approvalLine(payload)
                console.log('DELETE_APPROVAL_LINE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_APPROVAL_LINE', error)
            }
        },
        // @Description 전결권자 삭제
        async DELETE_ARBITER({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.delete.electapArbiter(payload)
                console.log('DELETE_ARBITER info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_ARBITER', error)
            }
        },
        // @Description 결재양식 코드로 조회
        async ELECTAP_FORM_CODE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.electapFormCode(payload)
                console.log('ELECTAP_FORM_CODE info', res)
                if (res.data.status === 200) {
                    commit('ELECTAP_FORM_CODE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('ELECTAP_FORM_CODE', error)
            }
        },
        // @Description 휴가결재 양식 조회
        async VACATION_FORM({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.vacationUse(payload)
                console.log('VACATION_FORM info', res)
                if (res.data.status === 200) {
                    commit('VACATION_FORM', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('VACATION_FORM', error)
            }
        },
        // @Description 휴가결재 저장
        async SUBMIT_VACATION({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.post.vacationUse(payload)
                console.log('SUBMIT_VACATION info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SUBMIT_VACATION', error)
            }
        },
        // @Description 휴가결재 삭제
        async DELETE_VACATION({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.delete.vacationUse(payload)
                console.log('DELETE_VACATION info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_VACATION', error)
            }
        },
        // @Description 저장된 휴가결재 상세조회
        async VACATION_FORM_DETAIL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.vacationUseDetail(payload)
                console.log('VACATION_FORM_DETAIL info', res)
                if (res.data.status === 200) {
                    commit('APPROVAL_COMMON', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('VACATION_FORM_DETAIL', error)
            }
        },
        // @Description 결재진행현황 조회
        async ELECTAP_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.electapDocumentList(payload)
                console.log('ELECTAP_LIST info', res)
                if (res.data.status === 200) {
                    commit('ELECTAP_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('ELECTAP_LIST', error)
            }
        },
        // @Description 참조문서 조회
        async ELECTAP_LIST_REF({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.electapDocumentRef(payload)
                console.log('ELECTAP_LIST_REF info', res)
                if (res.data.status === 200) {
                    commit('ELECTAP_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('ELECTAP_LIST_REF', error)
            }
        },
        // @Description 반려/회수문서 조회
        async ELECTAP_LIST_RECALL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.electapDocumentRecall(payload)
                console.log('ELECTAP_LIST_RECALL info', res)
                if (res.data.status === 200) {
                    commit('ELECTAP_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('ELECTAP_LIST_RECALL', error)
            }
        },
        // @Description 결재문서 첨부파일 등록
        async ELECTAP_FORM_FILE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.post.electapDocumentFile(payload)
                console.log('ELECTAP_FORM_FILE info', res)
                if (res.data.status === 201) {

                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('ELECTAP_FORM_FILE', error)
            }
        },
        // @Description 결재문서 의견글 등록
        async ELECTAP_COMMENT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.post.electapDocumentComment(payload)
                console.log('ELECTAP_COMMENT info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('ELECTAP_COMMENT', res.data.data.electapDocumentComment)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('ELECTAP_COMMENT', error)
            }
        },
        // @Description 결재문서 의견글 삭제
        async DELETE_ELECTAP_COMMENT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.delete.electapDocumentComment(payload)
                console.log('DELETE_ELECTAP_COMMENT info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_ELECTAP_COMMENT', payload.idx)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_ELECTAP_COMMENT', error)
            }
        },
        // @Description 결재문서 승인/반려
        async ELECTAP_SIGN({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.post.signDocument(payload)
                console.log('ELECTAP_SIGN info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('ELECTAP_SIGN', error)
            }
        },
        // @Description 결재문서 첨부파일 삭제
        async DELETE_APPROVAL_FILE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await common.delete.fileDeleteAsync(payload)
                console.log('DELETE_APPROVAL_FILE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_APPROVAL_FILE', res.data.data.commonAttachFileIdx)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_APPROVAL_FILE', error)
            }
        },
        // @Description 결재문서 회수
        async RECALL_APPROVAL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.post.electapDocumentRecall(payload)
                console.log('RECALL_APPROVAL info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RECALL_APPROVAL', error)
            }
        },
        // @Description 직원월례획의록 리스트 조회
        async MEETING_LOG_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.meetingLogList(payload)
                console.log('MEETING_LOG_LIST info', res)
                if (res.data.status === 200) {
                    commit('MEETING_LOG_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('MEETING_LOG_LIST', error)
            }
        },
        // @Description 직원월례회의록 신규작성 시 조회
        async MEETING_LOG({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.meetingLog(payload)
                console.log('MEETING_LOG info', res)
                if (res.data.status === 200) {
                    commit('MEETING_LOG', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('MEETING_LOG', error)
            }
        },
        // @Description 직원월례회의록 상세조회(저장된 내용)
        async MEETING_LOG_DETAIL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.meetingLogDetail(payload)
                console.log('MEETING_LOG_DETAIL info', res)
                if (res.data.status === 200) {
                    commit('APPROVAL_COMMON', res.data.data)
                    commit('MEETING_LOG_DETAIL', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('MEETING_LOG_DETAIL', error)
            }
        },
        // @Description 직원월례회의록 참석자 삭제
        async DELETE_MEETING_ATTENDANCE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.delete.meetingAttend(payload)
                console.log('DELETE_MEETING_ATTENDANCE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: `${payload.name} 선생님을 참석자 명단에서 제외했습니다.`, color: 'success' })
                    commit('DELETE_MEETING_ATTENDANCE', payload.index)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_MEETING_ATTENDANCE', error)
            }
        },
        // @Descripition 
        async DELETE_MEETING_ATTENDANCE_GROUP({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.delete.meetingAttend({
                    cbidx: payload.cbidx,
                    luidx: payload.luidx,
                    idx: payload.idx
                })
                console.log('DELETE_MEETING_ATTENDANCE_GROUP info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: `참석자 명단에서 선택하신 선생님들을 제외했습니다.`, color: 'success' })
                    commit('DELETE_MEETING_ATTENDANCE_GROUP', payload)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_MEETING_ATTENDANCE_GROUP', error)
            }
        },
        // @Description 직원월례회의록 저장
        async REGIST_MEETING_LOG({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.post.meetingLog(payload)
                console.log('REGIST_MEETING_LOG info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_MEETING_LOG', error)
            }
        },
        // @Description 직원회의록 참석자 개인별 알림
        async PERSONAL_PUSH({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.post.pushMeetingOne(payload)
                console.log('PERSONAL_PUSH info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: `${payload.name} 선생님에게 참석요청알림을 발송했습니다.`, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('PERSONAL_PUSH', error)
            }
        },
        // @Description 교육일지 신규작성 시 조회
        async EDUCATION_LOG({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.staffEducation(payload)
                console.log('EDUCATION_LOG info', res)
                if (res.data.status === 200) {
                    commit('EDUCATION_LOG', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('EDUCATION_LOG', error)
            }
        },
        // @Description 교육일지 상세조회
        async EDUCATION_LOG_DETAIL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.staffEducationDetail(payload)
                console.log('EDUCATION_LOG_DETAIL info', res)
                if (res.data.status === 200) {
                    commit('APPROVAL_COMMON', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('EDUCATION_LOG_DETAIL', error)
            }
        },
        // @Description 직원월례회의록 저장
        async REGIST_EDUCATION_LOG({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.post.staffEducation(payload)
                console.log('REGIST_EDUCATION_LOG info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_EDUCATION_LOG', error)
            }
        },
        // @Description 고충관리대장 조회
        async DISTRESSES_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.distressesList(payload)
                console.log('DISTRESSES_LIST info', res)
                if (res.data.status === 200) {
                    commit('DISTRESSES_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DISTRESSES_LIST', error)
            }
        },
        // @Description 고충관리결재 상세조회
        async DISTRESS_DETAIL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.distressesDetail(payload)
                console.log('DISTRESS_DETAIL info', res)
                if (res.data.status === 200) {
                    if (!payload.idx) {
                        commit('DISTRESS_DETAIL', res.data.data)
                    } else {
                        commit('APPROVAL_COMMON', res.data.data)
                    }
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DISTRESS_DETAIL', error)
            }
        },
        // @Description 고충일지 저장(결재)
        async REGIST_DISTRESS({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.post.distresses(payload)
                console.log('REGIST_DISTRESS info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_DISTRESS', error)
            }
        },
        // @Description 응급상황기록지 작성조회
        async EMERGENCY_FORM({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.emergencyReport(payload)
                console.log('EMERGENCY_FORM info', res)
                if (res.data.status === 200) {
                    commit('EMERGENCY_FORM', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('EMERGENCY_FORM', error)
            }
        },
        // @Description 응급상황기록지 상세조회
        async EMERGENCY_DETAIL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.emergencyDetail(payload)
                console.log('EMERGENCY_DETAIL info', res)
                if (res.data.status === 200) {
                    commit('APPROVAL_COMMON', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('EMERGENCY_DETAIL', error)
            }
        },
        // @Description 응급상황기록지 저장
        async REGIST_EMERGENCY_REPORT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.post.emergencyReport(payload)
                console.log('REGIST_EMERGENCY_REPORT info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_EMERGENCY_REPORT', error)
            }
        },
        // @Description 응급상황기록지 상세조회
        async EMERGENCY_DETAIL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.emergencyDetail(payload)
                console.log('EMERGENCY_DETAIL info', res)
                if (res.data.status === 200) {
                    commit('APPROVAL_COMMON', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('EMERGENCY_DETAIL', error)
            }
        },
        // @Description 응급상황기록지 프린트
        async EMERGENCY_REPORT_PRINT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.emergencyPrint(payload)
                console.log('EMERGENCY_REPORT_PRINT info', res)
                if (res.data.status === 200) {
                    
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('EMERGENCY_REPORT_PRINT', error)
            }
        },
        // @Description 사례관리 리스트 조회
        async CASE_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.caseReportList(payload)
                console.log('CASE_LIST info', res)
                if (res.data.status === 200) {
                    commit('CASE_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('CASE_LIST', error)
            }
        },
        // @Description 사례관리 신규조회
        async CASE_REPORT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.caseReport(payload)
                console.log('CASE_REPORT info', res)
                if (res.data.status === 200) {
                    commit('CASE_REPORT', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('CASE_REPORT', error)
            }
        },
        // @Description 사례관리 수정조회
        async CASE_REPORT_DETAIL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.caseReportDetail(payload)
                console.log('CASE_REPORT_DETAIL info', res)
                if (res.data.status === 200) {
                    commit('APPROVAL_COMMON', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('CASE_REPORT_DETAIL', error)
            }
        },
        // @Description 사례관리 등록
        async REGIST_CASE_REPORT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.post.caseReport(payload)
                console.log('REGIST_CASE_REPORT info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_CASE_REPORT', error)
            }
        },
        // @Description SMS 발송내역 조회
        async SMS_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.smsList(payload)
                console.log('SMS_LIST info', res)
                if (res.data.status === 200) {
                    commit('SMS_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SMS_LIST', error)
            }
        },
        // @Description 물품관리대장 목록 조회
        async ITEM_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.itemList(payload)
                console.log('ITEM_LIST info', res)
                if (res.data.status === 200) {
                    commit('ITEM_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('ITEM_LIST', error)
            }
        },
        // @Description 물품관리대장 구매목록 조회
        async ITEM_PURCHASE_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.medicinePurchase(payload)
                console.log('ITEM_PURCHASE_LIST info', res)
                if (res.data.status === 200) {
                    commit('ITEM_PURCHASE_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('ITEM_PURCHASE_LIST', error)
            }
        },
        // @Description 물품관리대장 물품사용목록 조회
        async ITEM_USAGE_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.itemUsageList(payload)
                console.log('ITEM_USAGE_LIST info', res)
                if (res.data.status === 200) {
                    commit('ITEM_USAGE_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('ITEM_USAGE_LIST', error)
            }
        },
        // @Description 물품구매이력 등록
        async REGIST_ITEM_PURCHASE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.post.medicinePurchase(payload)
                console.log('REGIST_ITEM_PURCHASE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('REGIST_ITEM_PURCHASE', payload.medicinePurchaseDTO[0])
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_ITEM_PURCHASE', error)
            }
        },
        // @Description 물품구매이력 삭제
        async DELETE_ITEM_PURCHASE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.delete.medicinePurchase(payload)
                console.log('DELETE_ITEM_PURCHASE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_ITEM_PURCHASE', payload.idx)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_ITEM_PURCHASE', error)
            }
        },
        // @Description 결재문서 삭제(공통)
        async DELETE_APPROVAL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.delete.electapDocument(payload)
                console.log('DELETE_APPROVAL info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_APPROVAL', error)
            }
        },
        // @Description 관련문서 수행일지 조회
        async REF_PERFORM_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.searchPerformLog(payload)
                console.log('REF_PERFORM_LIST info', res)
                if (res.data.status === 200) {
                    commit('REF_PERFORM_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REF_PERFORM_LIST', error)
            }
        },
        // @Description 관련문서 상태변화기록지 조회
        async REF_STATE_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.searchStateReport(payload)
                console.log('REF_STATE_LIST info', res)
                if (res.data.status === 200) {
                    commit('REF_STATE_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REF_STATE_LIST', error)
            }
        },
        // @Description 관련문서 급여제공계획서 조회
        async REF_SERVICE_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.searchOfferPlan(payload)
                console.log('REF_SERVICE_LIST info', res)
                if (res.data.status === 200) {
                    commit('REF_SERVICE_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REF_SERVICE_LIST', error)
            }
        },
        // @Description 포상관리 리스트 조회
        async REWARD_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.rewardList(payload)
                console.log('REWARD_LIST info', res)
                if (res.data.status === 200) {
                    commit('REWARD_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REWARD_LIST', error)
            }
        },
        // @Description 포상관리 최초조회
        async REWARD({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.reward(payload)
                console.log('REWARD info', res)
                if (res.data.status === 200) {
                    commit('REWARD', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REWARD', error)
            }
        },
        // @Description 포상관리 상세조회
        async REWARD_DETAIL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.rewardDetail(payload)
                console.log('REWARD_DETAIL info', res)
                if (res.data.status === 200) {
                    commit('APPROVAL_COMMON', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REWARD_DETAIL', error)
            }
        },
        // @Description 포상관리 저장
        async REGIST_REWARD({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.post.reward(payload)
                console.log('REGIST_REWARD info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_REWARD', error)
            }
        },
        // @Description 사직서 신규조회
        async STAFF_RESIGN({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.resign(payload)
                console.log('STAFF_RESIGN info', res)
                if (res.data.status === 200) {
                    commit('STAFF_RESIGN', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STAFF_RESIGN', error)
            }
        },
        // @Description 사직서 수정조회
        async STAFF_RESIGN_DETAIL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.resignDetail(payload)
                console.log('STAFF_RESIGN_DETAIL info', res)
                if (res.data.status === 200) {
                    commit('APPROVAL_COMMON', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STAFF_RESIGN_DETAIL', error)
            }
        },
        // @Description 사직서 등록
        async REGIST_STAFF_RESIGN({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.post.resign(payload)
                console.log('REGIST_STAFF_RESIGN info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_STAFF_RESIGN', error)
            }
        },
        // @Description 출퇴근 결재 조회
        async STAFF_COMMUTE_APPROVAl({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.commuteApproval(payload)
                console.log('STAFF_COMMUTE_APPROVAl info', res)
                if (res.data.status === 200) {
                    commit('STAFF_COMMUTE_APPROVAl', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STAFF_COMMUTE_APPROVAl', error)
            }
        },
        // @Description 출퇴근 결재 상세조회
        async STAFF_COMMUTE_APPROVAL_DETAIL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.commuteApprovalDetail(payload)
                console.log('STAFF_COMMUTE_APPROVAL_DETAIL info', res)
                if (res.data.status === 200) {
                    commit('APPROVAL_COMMON', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STAFF_COMMUTE_APPROVAL_DETAIL', error)
            }
        },
        // @Description 출퇴근 결재 등록
        async REGIST_STAFF_COMMUTE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.post.commuteApproval(payload)
                console.log('REGIST_STAFF_COMMUTE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_STAFF_COMMUTE', error)
            }
        },
        // @Description 기본기안문서 조회
        async COMMON_APPROVAl({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.commonDocument(payload)
                console.log('COMMON_APPROVAl info', res)
                if (res.data.status === 200) {
                    commit('COMMON_APPROVAl', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('COMMON_APPROVAl', error)
            }
        },
        // @Description 기본기안문서 상세조회
        async COMMON_APPROVAl_DETAIL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.commonDocumentDetail(payload)
                console.log('COMMON_APPROVAl_DETAIL info', res)
                if (res.data.status === 200) {
                    commit('APPROVAL_COMMON', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('COMMON_APPROVAl_DETAIL', error)
            }
        },
        // @Description 기본기안문서 등록
        async REGIST_COMMON_APPROVAL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.post.commonDocument(payload)
                console.log('REGIST_COMMON_APPROVAL info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_COMMON_APPROVAL', error)
            }
        },
        // @Description 빠른 휴가 신청
        async REGIST_QUICK_VACATION({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.post.vacationUseQuick(payload)
                console.log('REGIST_QUICK_VACATION info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_QUICK_VACATION', error)
            }
        },
        // @Description 결제내역 조회
        async PAYMENT_HISTORY({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.paymentHistory(payload)
                console.log('PAYMENT_HISTORY info', res)
                if (res.data.status === 200) {
                    commit('PAYMENT_HISTORY', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('PAYMENT_HISTORY', error)
            }
        },
        // @Description 직원의 출퇴근정보 프린트(신규)
        async STAFF_COMMUTE_PRINT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.staffCommutePrint(payload)
                console.log('STAFF_COMMUTE_PRINT info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STAFF_COMMUTE_PRINT', error)
            }
        },
        // @Description 직원의 출퇴근정보 조회(여러명 조회가능)
        async STAFF_COMMUTE_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.staffCommuteList(payload)
                console.log('STAFF_COMMUTE_LIST info', res)
                if (res.data.status === 200) {
                    commit('STAFF_COMMUTE_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STAFF_COMMUTE_LIST', error)
            }
        },
        // @Description 기관의 모든휴일 조회(토,일 제회)
        async YEAR_HOLIDAY({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.get.holiday(payload)
                console.log('YEAR_HOLIDAY info', res)
                if (res.data.status === 200) {
                    commit('YEAR_HOLIDAY', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('YEAR_HOLIDAY', error)
            }
        },
        // @Description 직원의 출퇴근정보 삭제(개별, 전체)
        async DELETE_STAFF_ALL_COMMUTE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.delete.staffCommute(payload)
                console.log('DELETE_STAFF_ALL_COMMUTE info', res)
                if (res.data.status === 201) {
                    commit('DELETE_STAFF_ALL_COMMUTE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_STAFF_ALL_COMMUTE', error)
            }
        },
        // @Description 취소/환불 요청
        async PAYMENT_REFUND({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.post.refund(payload)
                console.log('PAYMENT_REFUND info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('PAYMENT_REFUND', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('PAYMENT_REFUND', error)
            }
        },
        // @Description 근태 수정
        async UPDATE_STAFF_COMMUTE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.post.staffCommuteDay(payload)
                console.log('UPDATE_STAFF_COMMUTE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('UPDATE_STAFF_COMMUTE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPDATE_STAFF_COMMUTE', error)
            }
        },
        // @Description 근태요청 확정/반려
        async REQUEST_CONFIRM({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.post.requestCommute(payload)
                console.log('REQUEST_CONFIRM info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('REQUEST_CONFIRM', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REQUEST_CONFIRM', error)
            }
        },
        // @Description 근태요청 삭제
        async DELETE_REQUEST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.delete.requestCommute(payload)
                console.log('DELETE_REQUEST info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_REQUEST', payload)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_REQUEST', error)
            }
        },
        // @Description 근태 확정
        async CLOSE_COMMUTE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.post.commuteCloseDay(payload)
                console.log('CLOSE_COMMUTE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('CLOSE_COMMUTE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('CLOSE_COMMUTE', error)
            }
        },
        // @Description 급여(임금)정산 마감 기안 조회
        async PAYSLIP_REPORT_TO_CLOSE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.payslipClose(payload)
                console.log('PAYSLIP_REPORT_TO_CLOSE info', res)
                if (res.data.status !== 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                } else {
                    commit('PAYSLIP_REPORT', res.data.data)
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('PAYSLIP_REPORT_TO_CLOSE error', error)
            }
        },
        // @Description 급여(임금)정산 마감 기안 상세조회
        async PAYSLIP_REPORT_TO_CLOSE_DETAIL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.payslipCloseDetail(payload)
                console.log('PAYSLIP_REPORT_TO_CLOSE_DETAIL info', res)
                if (res.data.status !== 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                } else {
                    commit('APPROVAL_COMMON', res.data.data)
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('PAYSLIP_REPORT_TO_CLOSE_DETAIL error', error)
            }
        },
        // @Description 종사자 급여정산 마감 저장
        async REGIST_PAYSLIP_REPORT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.post.payslipClose(payload)
                console.log('REGIST_PAYSLIP_REPORT info', res)
                if (res.data.status !== 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_PAYSLIP_REPORT error', error)
            }
        },
        // @Description 기관운영관리 대시보드 조회
        async MANAGEMENT_DASH({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.managementDash(payload)
                console.log('MANAGEMENT_DASH info', res)
                if (res.data.status !== 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                } else {
                    commit('MANAGEMENT_DASH', res.data.data)
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('MANAGEMENT_DASH error', error)
            }
        },
        // @Description 수급자수 목표달성 계획 조회
        async RECEIVER_GOAL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.receiverGoal(payload)
                console.log('RECEIVER_GOAL info', res)
                if (res.data.status !== 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                } else {

                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RECEIVER_GOAL error', error)
            }
        },
        // @Description 수급자수 목표달성 계획 저장
        async REGIST_RECEIVER_GOAL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.post.receiverGoal(payload)
                console.log('REGIST_RECEIVER_GOAL info', res)
                if (res.data.status !== 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                } else {
                    commit('REGIST_RECEIVER_GOAL', res.data.data)
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_RECEIVER_GOAL error', error)
            }
        },
        // @Description 수급자수 목표달성 계획 전체삭제(년도)
        async DELETE_RECEIVER_GOAL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.delete.receiverGoal(payload)
                console.log('DELETE_RECEIVER_GOAL info', res)
                if (res.data.status !== 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                } else {
                    commit('DELETE_RECEIVER_GOAL', res.data.data)
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_RECEIVER_GOAL error', error)
            }
        },
        // @Description 수급자 이용일수 월별 조회
        async USE_DAY({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.dashUseday(payload)
                console.log('USE_DAY info', res)
                if (res.data.status === 200) {
                    commit('USE_DAY', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('USE_DAY error', error)
            }
        },
        // @Description 수급자 한도금액 사용현황 월별조회
        async DASH_LIMIT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.dashLimit(payload)
                console.log('DASH_LIMIT info', res)
                if (res.data.status === 200) {
                    commit('DASH_LIMIT', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DASH_LIMIT error', error)
            }
        },
        // @Description 사직서 프린트
        async RESIGN_PRINT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.resignPrint(payload)
                console.log('RESIGN_PRINT info', res)
                if (res.data.status === 200) {

                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RESIGN_PRINT error', error)
            }
        },
        // @Description 직원회의록 프린트
        async MEETING_LOG_PRINT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.meetingLogPrint(payload)
                console.log('MEETING_LOG_PRINT info', res)
                if (res.data.status === 200) {

                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('MEETING_LOG_PRINT error', error)
            }
        },
        // @Description 기본기안문서 프린트
        async COMMON_REPORT_PRINT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.commonDocumentPrint(payload)
                console.log('COMMON_REPORT_PRINT info', res)
                if (res.data.status === 200) {

                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('COMMON_REPORT_PRINT error', error)
            }
        },
        // @Description 휴가신청서 프린트
        async VACATION_REPORT_PRINT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.vacationUsePrint(payload)
                console.log('VACATION_REPORT_PRINT info', res)
                if (res.data.status === 200) {

                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('VACATION_REPORT_PRINT error', error)
            }
        },
        // @Description 사례회의록 프린트
        async CASE_REPORT_PRINT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.caseReportPrint(payload)
                console.log('CASE_REPORT_PRINT info', res)
                if (res.data.status === 200) {

                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('CASE_REPORT_PRINT error', error)
            }
        },
        // @Description 교육일지 프린트
        async EDUCATION_REPORT_PRINT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.staffEducationPrint(payload)
                console.log('EDUCATION_REPORT_PRINT info', res)
                if (res.data.status === 200) {

                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('EDUCATION_REPORT_PRINT error', error)
            }
        },
        // @Description 포상관리 프린트
        async REWARD_PRINT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.rewardPrint(payload)
                console.log('REWARD_PRINT info', res)
                if (res.data.status === 200) {

                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REWARD_PRINT error', error)
            }
        },
        // @Description 포상관리 포상자 알림발송
        async PUSH_REWARD({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.post.rewardPush(payload)
                console.log('PUSH_REWARD info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('PUSH_REWARD error', error)
            }
        },
        // @Description 완료된 전자결재문서 삭제
        async DELETE_DONE_DOCUMENT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.delete.electapDocumentEnd(payload)
                console.log('DELETE_DONE_DOCUMENT info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_DONE_DOCUMENT error', error)
            }
        },
        // @Description 고충상담일지 프린트 조회
        async DISTRESS_PRINT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.distressPrint(payload)
                console.log('DISTRESS_PRINT info', res)
                if (res.data.status === 200) {

                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DISTRESS_PRINT error', error)
            }
        },
        // @Description 교육일지 리스트 조회
        async APPROVAL_EDUCATION_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.staffEducationList(payload)
                console.log('APPROVAL_EDUCATION_LIST info', res)
                if (res.data.status === 200) {
                    commit('APPROVAL_EDUCATION_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('APPROVAL_EDUCATION_LIST error', error)
            }
        },
        // @Description 포상관리 포상대상 삭제
        async DELETE_EDU_STAFF({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.delete.rewardStaff(payload)
                console.log('DELETE_EDU_STAFF info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_EDU_STAFF error', error)
            }
        },
        // @Description 직원회의록 참석자 리스트 추가하기 
        async ADD_ATTEND_STAFF_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.post.mettingLogStaffAdd(payload)
                console.log('ADD_ATTEND_STAFF_LIST info', res)
                if (res.data.status === 201) {
                    commit('ADD_ATTEND_STAFF_LIST', res.data.data)
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('ADD_ATTEND_STAFF_LIST error', error)
            }
        },
        // @Description 법정의무교육목록 조회
        async GET_GRADUATION_LEGAL_EDU_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.eduFileList(payload)
                console.log('GET_GRADUATION_LEGAL_EDU_LIST info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('GET_GRADUATION_LEGAL_EDU_LIST error', error)
            }
        },
        // @Description 임직원 법정의무교육 수료증 업로드 관리
        async REGIST_LEGAL_GRADU_FILE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.post.fileUpload(payload)
                console.log('REGIST_ESS_FILE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_ESS_FILE error', error)
            }
        },
        // @Description 일일업무보고 조회
        async DAY_REPORT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.dayReport(payload)
                console.log('DAY_REPORT info', res)
                if (res.data.status === 200) {
                    commit('DAY_REPORT', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DAY_REPORT error', error)
            }
        },
        // @Description 일일업무보고 상세조회
        async DAY_REPORT_DETAIL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.dayReportDetail(payload)
                console.log('DAY_REPORT_DETAIL info', res)
                if (res.data.status === 200) {
                    commit('APPROVAL_COMMON', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DAY_REPORT_DETAIL error', error)
            }
        },
        // @Description 일일업무보고 등록
        async REGIST_DAY_REPORT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.post.dayReport(payload)
                console.log('REGIST_DAY_REPORT info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_DAY_REPORT', error)
            }
        },
        // @Description 비품 점검대장 조회
        async ITEM_LIST_REPORT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.approvalItemList(payload)
                console.log('ITEM_LIST_REPORT info', res)
                if (res.data.status === 200) {
                    commit('ITEM_LIST_REPORT', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('ITEM_LIST_REPORT error', error)
            }
        },
        // @Description 비품 점검대장 상세조회
        async ITEM_LIST_REPORT_DETAIL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.itemListDetail(payload)
                console.log('ITEM_LIST_REPORT_DETAIL info', res)
                if (res.data.status === 200) {
                    commit('APPROVAL_COMMON', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('ITEM_LIST_REPORT_DETAIL error', error)
            }
        },
        // @Description 비품 점검대장 저장
        async REGIST_ITEM_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.post.itemList(payload)
                console.log('REGIST_ITEM_LIST info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_ITEM_LIST', error)
            }
        },
        // @Description 운영위원회회의록 조회
        async STEERING_COMMITTEE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.steeringCommittee(payload)
                console.log('STEERING_COMMITTEE info', res)
                if (res.data.status === 200) {
                    commit('STEERING_COMMITTEE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STEERING_COMMITTEE error', error)
            }
        },
        // @Description 운영위원회회의록 상세조회
        async STEERING_COMMITTEE_DETAIL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.steeringCommitteeDetail(payload)
                console.log('STEERING_COMMITTEE_DETAIL info', res)
                if (res.data.status === 200) {
                    commit('APPROVAL_COMMON', res.data.data)
                    commit('STEERING_COMMITTEE_DETAIL', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STEERING_COMMITTEE_DETAIL error', error)
            }
        },
        // @Description 운영위원회회의록 등록
        async REGIST_STEERING_COMMITTEE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.post.steeringCommittee(payload)
                console.log('REGIST_STEERING_COMMITTEE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_STEERING_COMMITTEE', error)
            }
        },
        // @Description 운영위원회회의록 리스트 조회
        async STEERING_COMMITTEE_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.steeringCommitteeList(payload)
                console.log('STEERING_COMMITTEE_LIST info', res)
                if (res.data.status === 200) {
                    commit('STEERING_COMMITTEE_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STEERING_COMMITTEE_LIST error', error)
            }
        },
        // @Description 운영위원회회의록 프린트
        async STEERING_COMMITTEE_PRINT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.steeringCommitteePrint(payload)
                console.log('STEERING_COMMITTEE_PRINT info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('STEERING_COMMITTEE_DETAIL', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STEERING_COMMITTEE_PRINT error', error)
            }
        },
        // @Description 의약품 점검대장 프린트
        async ITEM_LIST_PRINT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await approval.get.itemListPrint(payload)
                console.log('ITEM_LIST_PRINT info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('ITEM_LIST_PRINT error', error)
            }
        },
    },
    getters: {
        FILTER_CATEGORY: state => {
            if (state.approvalCategory) {
                state.approvalCategory.unshift({
                    categoryName: '전체',
                    createUserIdx: 0,
                    createYmdhms: 0,
                    customerBranchIdx: 0,
                    electapFormCategoryIdx: 0,
                    momsbiLinkYn: 0,
                    updateUserIdx: 0,
                    updateYmdhms: 0,
                    useYn: 'Y'
                })
                return state.approvalCategory
            } else {
                return [{
                    categoryName: '전체',
                    createUserIdx: 0,
                    createYmdhms: 0,
                    customerBranchIdx: 0,
                    electapFormCategoryIdx: 0,
                    momsbiLinkYn: 0,
                    updateUserIdx: 0,
                    updateYmdhms: 0,
                    useYn: 'Y'
                }]
            }
        },
        FILTERED_APPROVAL: state => {
            if (!state.filters.length || state.filters.includes('전체')) {
                return state.approvalList
            } else {
                let arries = state.approvalList.reduce((forward, it) => {
                    if (it.categoryName === state.filters[0]) { forward.push(it); }
                    return forward
                }, [])

                return arries
            }
        },
        APPLY_FILTER_APPROVAL_LIST: state => {
            if (!state.filters.length || state.filters.includes('전체')) {
                return state.electapList
            } else {
                let arries = []
                if(state.electapList) {
                    arries = state.electapList.reduce((forward, it) => {
                        if (it.formName === state.filters[0])
                            forward.push(it);

                        return forward
                    }, [])
                }

                return arries
            }
        },
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/approvals.js